import { render, staticRenderFns } from "./CustomAttributesForm.vue?vue&type=template&id=73f877b2"
import script from "./CustomAttributesForm.vue?vue&type=script&lang=ts"
export * from "./CustomAttributesForm.vue?vue&type=script&lang=ts"
import style0 from "./CustomAttributesForm.vue?vue&type=style&index=0&id=73f877b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports